// Dashboard components
import MDButton from "components/MDButton";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

const DeleteButton = ({ onClick, disabled, tooltip, ...props }) => {
  return (
    <Tooltip title={tooltip}>
      <MDButton
        onClick={onClick}
        disabled={disabled}
        variant="gradient"
        iconOnly
        size="small"
        type="button"
        {...props}
        color={props?.style?.backgroundColor ? null : "error"}
        style={
          disabled
            ? { background: "grey", color: "white", marginLeft: "4px" }
            : props?.style
        }
      >
        <Icon>delete</Icon>
      </MDButton>
    </Tooltip>
  );
};

export default DeleteButton;
